// Face-api script + models are self-hosted under /face-models (cached by the service worker).
const BASE = `${process.env.PUBLIC_URL || ""}/face-models`;

// Drop any saved copy of the scanner files so the next load re-downloads them.
export async function clearFaceModelCache() {
    if (typeof caches === "undefined") return;
    for (const key of await caches.keys()) {
        const c = await caches.open(key);
        const reqs = await c.keys();
        await Promise.all(reqs.filter((r) => r.url.includes("/face-models/")).map((r) => c.delete(r)));
    }
}

const loadNets = () => Promise.all([
    window.faceapi.nets.tinyFaceDetector.loadFromUri(BASE),
    window.faceapi.nets.faceLandmark68Net.loadFromUri(BASE),
    window.faceapi.nets.faceRecognitionNet.loadFromUri(BASE),
]);

let _modelsReady = null;
export function ensureModels() {
    if (_modelsReady) return _modelsReady;
    _modelsReady = (async () => {
        if (typeof window.faceapi === "undefined") {
            await new Promise((resolve, reject) => {
                const s = document.createElement("script");
                s.src = `${BASE}/face-api.min.js`;
                s.async = true;
                s.onload = resolve;
                s.onerror = () => reject(new Error("Failed to load the face scanner"));
                document.head.appendChild(s);
            });
        }
        try {
            await loadNets();
        } catch (e) {
            // Usually a half-downloaded file saved on a weak connection: clear it and fetch fresh once.
            console.warn("Face models failed to load, re-downloading", e);
            await clearFaceModelCache();
            try {
                await loadNets();
            } catch (e2) {
                throw new Error("The face scanner didn't download completely");
            }
        }
    })().catch((e) => { _modelsReady = null; throw e; });
    return _modelsReady;
}

// Manual fallback: wipe the saved scanner and reload the page.
export async function resetFaceScanner() {
    await clearFaceModelCache().catch(() => {});
    window.location.reload();
}

let _warm = null;
// Runs the recognition net once on a blank image so the first real capture isn't slowed by GPU setup.
export function warmUpFaceModels() {
    if (!_warm) {
        _warm = ensureModels().then(() => {
            const c = document.createElement("canvas");
            c.width = c.height = 150;
            return window.faceapi.detectFaceLandmarks(c).then(() => window.faceapi.computeFaceDescriptor(c));
        }).catch(() => { _warm = null; });
    }
    return _warm;
}
